import React from 'react';
import { Form } from '@ant-design/compatible';
import cx from 'classnames';
import TextArea from '../../input/TextArea';
import CountLabel from '../../CountLabel';
import './TextAreaForm.scss';

const TextAreaForm = (props) => {
  const {
    form,
    label,
    rules,
    name,
    onChange,
    initialValue,
    isEditable = true,
    className,
    withCount,
    maxLength,
    vertical = false,
    showInfo = true,
    subContent,
    ...res
  } = props;
  const { getFieldDecorator } = form;

  return (
    <div className={className}>
      <Form.Item
        className={cx('textArea-form', 'amondz-form', { 'with-label': label }, { vertical })}
        label={
          isEditable && withCount ? (
            <CountLabel content={form.getFieldValue(name)} label={label} maxLength={maxLength} vertical={vertical} />
          ) : (
            label
          )
        }
      >
        {getFieldDecorator(name, {
          rules,
          initialValue,
          onChange: (value) => onChange && onChange(value),
        })(<TextArea isEditable={isEditable} maxLength={maxLength} {...res} />)}
      </Form.Item>

      {subContent && showInfo ? <div className="amondz-form-sub-content"> {subContent}</div> : null}
    </div>
  );
};

export default TextAreaForm;
